

<div *ngIf="lecturer" class="flex align-items-center gap-2">

  <app-user-avatar [user]="lecturer.user" [locketOrgId]="locketOrgId"></app-user-avatar>

  <div >
    <p class="font-bold text-sm m-0 we">
      <ng-container *ngIf="lecturer.nickname as nickname; else noNickname">
        {{ nickname }}
      </ng-container>
      <ng-template #noNickname>
        @if (lecturer.user; as u) {
          @if (userHelperService.getOrgUserFullname(u.orgUsers, selectedOrg.getCurrentValue(), true); as fullName) {
            {{ fullName }}
          }
        }
      </ng-template>
    </p>
    @if (lecturer.user?.email) {
      <p class="m-0 mt-1 text-color-secondary white-space-nowrap text-xs">
        {{ lecturer.user?.email }}
      </p>
    }
  </div>
</div>
